import React, { useState } from "react";
import "./LoginForm.scss";
import { useNavigate } from "react-router-dom"; // Cambia useHistory por useNavigate
import { login } from "../../api/authService";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import useAuth from "../../api/useAuth";

const LoginForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const { isAuthenticated } = useAuth();

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  const handleRedirect = async (e) => {
    e.preventDefault();
    try {
      const data = await login(email, password);
      localStorage.setItem("token", data.access_token);
      navigate("/dashboard");
    } catch (error) {
      if (error.message.includes("401")) {
        console.log("error");
      }
    }
  };

  if (isAuthenticated) {
    navigate("/dashboard");
  }

  return (
    <form className="formulario" onSubmit={handleRedirect}>
      <h1 className="titulo">Log in</h1>
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Email"
        className="input"
        required
      />
      <div
        className="password-input-container"
        style={{ position: "relative" }}
      >
        <input
          type={showPassword ? "text" : "password"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          className="input password"
          required
        />
        <button
          type="button"
          onClick={togglePasswordVisibility}
          className="toggle-password-btn"
          aria-label={
            showPassword ? "Ocultar contraseña" : "Mostrar contraseña"
          }
        >
          {showPassword ? <FaEyeSlash /> : <FaEye />}
        </button>
      </div>
      <button className="btn" type="submit">
        Log in
      </button>
      {/* <a className="reset-pass" href="/reset-password">
        Forgot Password?
      </a> */}
    </form>
  );
};

export default LoginForm;
